module.exports = __webpack_public_path__ + "img/goods9_3.51aa82f4.jpg";